import { Typography } from '@/components/primitives/Typography';
import { useBackgroundTheme } from '@/hooks/useBackgroundTheme';
import { TransText } from '@/i18n/trans/text';
import type { SearchNonTripOffersDTO } from '@/types/dto/agent';
import { isLightBackground } from '@/utils/color';
import type { FC } from 'react';

export const NonTripOffersNotFound: FC<SearchNonTripOffersDTO> = ({
  nonTripOffers,
}) => {
  const backgroundTheme = useBackgroundTheme();
  const isLight = isLightBackground(backgroundTheme);

  if (!nonTripOffers || nonTripOffers.length > 0) {
    return null;
  }

  return (
    <div className="mx-auto w-fit px-4 py-8 laptop:px-0">
      <Typography
        className={isLight ? 'text-neutral' : 'text-neutral-light'}
        variant="paragraph"
        data-testid="no-travel-passes-found-message"
      >
        <TransText i18nKey="noTravelPassesFoundPleaseChangeSearchInputsAndTryAgain" />
      </Typography>
    </div>
  );
};
